import React from 'react';
import PropTypes from 'prop-types'
export default function Contact(props) {
  return (
    <div className={props.mode}>
      <section className='contact' id="contact" >
        <h1 className="heading"> Contact <span> Me!</span></h1>
        <form action="https://api.web3forms.com/submit" method="POST" className="contact-form">
          <input type="hidden" name="access_key" value="f0d51e85-7006-4ad4-a4ec-86330d610401" />
          <div className="input-box">
            <input name="fullName" id="name" type="text" placeholder="Full Name" required />
            <input name="email" id="email" type="email" placeholder="Email Address" required />
          </div>
          <div className="input-box">
            <input name="mobNo" id="mobNo" type="number" placeholder="Mobile Number" required />
            <input name="sub" id="sub" type="text" placeholder="Email Subject" required />
          </div>
          <div className="mobtxtarea">
            <textarea name="msg" id="msg" cols="30" rows="5" placeholder="Your Message" required></textarea>
            <input id="btn" type="submit" value="Send Message" className="subBtn" />
          </div>
        </form>
        <script src="https://smtpjs.com/v3/smtp.js"></script>
      </section >
    </div>
  );
}
